/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateUserSessionIssuerForm,
  UpdateUserSessionIssuerForm$Outbound,
  UpdateUserSessionIssuerForm$outboundSchema,
} from "../components/updateusersessionissuerform.js";

export type UpdateUserSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateUserSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateUserSessionIssuerSecurity = {
  option1?: UpdateUserSessionIssuerSecurityOption1 | undefined;
  option2?: UpdateUserSessionIssuerSecurityOption2 | undefined;
};

export type UpdateUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateUserSessionIssuerForm: UpdateUserSessionIssuerForm;
};

/** @internal */
export type UpdateUserSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateUserSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateUserSessionIssuerSecurityOption1$Outbound,
    UpdateUserSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateUserSessionIssuerSecurityOption1ToJSON(
  updateUserSessionIssuerSecurityOption1:
    UpdateUserSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateUserSessionIssuerSecurityOption1$outboundSchema.parse(
      updateUserSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateUserSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateUserSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateUserSessionIssuerSecurityOption2$Outbound,
    UpdateUserSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateUserSessionIssuerSecurityOption2ToJSON(
  updateUserSessionIssuerSecurityOption2:
    UpdateUserSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateUserSessionIssuerSecurityOption2$outboundSchema.parse(
      updateUserSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateUserSessionIssuerSecurity$Outbound = {
  Option1?: UpdateUserSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: UpdateUserSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateUserSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  UpdateUserSessionIssuerSecurity$Outbound,
  UpdateUserSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateUserSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateUserSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateUserSessionIssuerSecurityToJSON(
  updateUserSessionIssuerSecurity: UpdateUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    UpdateUserSessionIssuerSecurity$outboundSchema.parse(
      updateUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type UpdateUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateUserSessionIssuerForm: UpdateUserSessionIssuerForm$Outbound;
};

/** @internal */
export const UpdateUserSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  UpdateUserSessionIssuerRequest$Outbound,
  UpdateUserSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateUserSessionIssuerForm: UpdateUserSessionIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateUserSessionIssuerForm: "UpdateUserSessionIssuerForm",
    });
  }),
);

export function updateUserSessionIssuerRequestToJSON(
  updateUserSessionIssuerRequest: UpdateUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    UpdateUserSessionIssuerRequest$outboundSchema.parse(
      updateUserSessionIssuerRequest,
    ),
  );
}
